<ng-container *transloco="let t; read: 'revisions.detail'">
  <div class="xs12col">
    <div class="fieldsetWrapper margin-bottom-medium margin-right-small">
      <kendo-tabstrip (tabSelect)="onTabSelect($event)">
        <kendo-tabstrip-tab [title]="t('devicesToMaintain')" [selected]="true">
          <ng-template kendoTabContent>
            <app-manage-devices [revisionId]="revisionId" [revisionStatus]="revisionStatus" [companyId]="companyId" [tenantOnRevision]="tenantOnRevision"></app-manage-devices>
          </ng-template>
        </kendo-tabstrip-tab>

        <kendo-tabstrip-tab [title]="t('addDeviceToRevision')" [selected]="false" [disabled]="revisionStatus?.isFinalStatus == true || !('Permissions.Revisions.AddDevice' | permission)">
          <ng-template kendoTabContent>
            <app-add-devices [revisionId]="revisionId" [revisionStatus]="revisionStatus" [companyId]="companyId" [tenantOnRevision]="tenantOnRevision"></app-add-devices>
          </ng-template>
        </kendo-tabstrip-tab>
      </kendo-tabstrip>
    </div>
  </div>
</ng-container>